<template>
    <p v-if="sharedBy" class="shared-copy-notice">
        <span class="icon material-symbols-outlined">group</span>
        <span>
            {{ sharedBy }} shared this {{ itemLabel }} with you. This is your
            own copy, so your changes won't affect the original.
        </span>
    </p>
</template>

<script>
export default {
    name: "SharedCopyNotice",
    props: {
        sharedBy: {
            type: String,
            default: null,
        },
        itemLabel: {
            type: String,
            required: true,
        },
    },
};
</script>
